import React, { FormEventHandler, useState } from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  TextFieldProps,
  Typography,
} from '@mui/material';

type Props = {
  open: boolean;
  handleClose: () => void;
  textFieldProps: Omit<TextFieldProps, 'value' | 'onChange'>;
  title: string;
  description: string;
  placeholder: string;
  loading: boolean;
  confirmButtonLabel?: string;
  onSubmit: (v: string) => Promise<void>;
};

export default function PromptTextDialog({
  open,
  handleClose,
  description,
  loading,
  title,
  onSubmit,
  placeholder,
  confirmButtonLabel = 'Ok',
  textFieldProps,
}: Props) {
  const [value, setValue] = useState('');
  const handleSubmit: FormEventHandler<HTMLFormElement> = async (ev) => {
    ev.preventDefault();
    await onSubmit(value);
    handleClose();
  };
  return (
    <Dialog open={open} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <Typography color="text.secondary" paragraph>
            {description}
          </Typography>
          <TextField
            margin="normal"
            autoFocus
            placeholder={placeholder}
            fullWidth
            value={value}
            onChange={(ev) => setValue(ev.target.value)}
            {...textFieldProps}
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button disabled={loading} type="submit" color="primary" variant="contained">
            {confirmButtonLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
